import { AppState } from '../reducers';
import { createSelector } from 'reselect';

export const getLeadRouteState = (state: AppState) => state.leadRoutes;

export const getLeadRouteOriginPage = createSelector(
    [getLeadRouteState],
    leadRouteState => leadRouteState.origin
);